import { Controller } from "web-ui/controller"
import * as Log from "web-ui/log"

// Connects to data-controller="confirmation-field"
export default class extends Controller {
  static values = {
    confirmationButtonId: String,
    confirmationText: String,
    debug: Boolean
  };

  static events = {
    "change": "confirm",
    "input": "confirm"
  }

  connect() {
    this.debug("Connect", { confirmationButtonId: this.confirmationButtonIdValue, confirmationText: this.confirmationTextValue })

    this.confirm()
  }

  disconnect() {
    this.debug("Disconnect")
  }

  confirm() {
    const text = this.element.value

    this.debug("Confirming", { inputText: text, confirmationText: this.confirmationTextValue })

    const confirmationButtonElement = document.getElementById(this.confirmationButtonIdValue)

    if (this.isConfirmed(text)) {
      confirmationButtonElement.removeAttribute("disabled")
    } else {
      confirmationButtonElement.setAttribute("disabled", "disabled")
    }
  }

  isConfirmed(text) {
    text = text.toLowerCase()
    text = text.trim()

    let confirmationText = this.confirmationTextValue.toLowerCase()
    confirmationText = confirmationText.trim()

    return text === confirmationText
  }

  debug(message, data) {
    Log.debug("Confirmation Field - " + message, data)
  }
}
